import React from 'react';
import BaseModal, {
	BaseModalProps,
} from '../../../../../Base/Components/BaseModal/BaseModal';
import { Size } from '../../../../../../Enums/Size.enum';
import ManagerInsuranceCompaniesBatchCreateForm from './ManagerInsuranceCompaniesBatchCreateForm';

import { InsuranceCompanyBatch } from '../../../../Consts/InsuranceCompanyBatchesDefaultColumns.const';

interface Props extends BaseModalProps {
	onSuccess: (batches: InsuranceCompanyBatch[]) => void;
	reloadData: () => void;
}

const ManagerInsuranceCompaniesBatchCreateModal = ({
	onSuccess,
	reloadData,
	...modalProps
}: Props) => {
	return (
		<BaseModal
			{...modalProps}
			title={'component.insuranceCompanyBatch.createForm.title'}
			size={Size.MD}>
			<ManagerInsuranceCompaniesBatchCreateForm
				onSuccess={onSuccess}
				reloadData={reloadData}
			/>
		</BaseModal>
	);
};

export default ManagerInsuranceCompaniesBatchCreateModal;
